<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div id="pageItemList">
    <v-layout row class="align-center layout px-4 pt-4 app--page-header">
      <div class="page-header-left">
        <h3 class="pr-3">
          <v-icon>assignment</v-icon>
          {{ $t("reviewReport") }} #{{ reviewReport.rma }}
        </h3>
      </div>
      <v-breadcrumbs divider="-" :items="breadcrumbs"> </v-breadcrumbs>
    </v-layout>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex md6>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title>{{ $t("vehicle") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">train</v-icon>
            </v-toolbar>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ reviewReport.vehicle.name }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("vehicle") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ reviewReport.odometer }} km
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("odometer") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ $moment(reviewReport.review_date).format("LL") }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("reviewDate") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ reviewReport.based }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("reviewReportBased") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ $t("reviewPlaces." + reviewReport.review_place) }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("reviewPlace") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md6>
          <v-card style="margin-bottom: 20px">
            <v-toolbar card>
              <v-toolbar-title>{{ $t("reviewType") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">assignment</v-icon>
            </v-toolbar>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ reviewReport.type }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("reviewType") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>

              <div v-if="reviewReport.type === 'PX'">
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ reviewReport.subcontractor }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{ $t("reviewReportSubcontractor") }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ reviewReport.subcontractor_device_name }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{ $t("reviewReportSubcontractorDeviceName") }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </div>

              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ reviewReport.warranty_repairs | booleanText }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("warrantyRepairs") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>

          <v-card v-if="reviewDurationVisible">
            <v-toolbar card>
              <v-toolbar-title>{{ $t("reviewDuration") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">access_time</v-icon>
            </v-toolbar>

            <v-list two-line>
              <v-list-tile>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ reviewDurationTime | detailedDuration }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ $t("reviewDuration") }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex md6> </v-flex>

        <v-flex md12>
          <v-card>
            <v-toolbar card>
              <v-toolbar-title>{{ $t("consumables") }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary">queue</v-icon>
            </v-toolbar>

            <v-card-text>
              <nl2br tag="p" :text="reviewReport.used_consumables" />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import { FETCH_REVIEW_REPORT } from "@/store/actions.type";
import {
  VEHICLE_CANT_WORK,
  VEHICLE_OUT_OF_ORDER
} from "@/common/enums/issueCategories";

export default {
  data() {
    return {
      VEHICLE_OUT_OF_ORDER: VEHICLE_OUT_OF_ORDER,
      VEHICLE_CANT_WORK: VEHICLE_CANT_WORK,
      breadcrumbs: [
        {
          text: this.$t("reviewReports"),
          to: { name: "ReviewReports" },
          exact: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["reviewReport", "reviewReportIsLoading"]),
    reviewDurationVisible() {
      return (
        this.reviewReport.worklog.own_work.work_start &&
        this.reviewReport.worklog.own_work.made_review_p1
      );
    },
    reviewDurationTime() {
      if (this.reviewDurationVisible) {
        let workStartMoment = this.$moment(
          this.reviewReport.worklog.own_work.work_start
        );
        let workFinishMoment = this.$moment(
          this.reviewReport.worklog.own_work.made_review_p1
        );

        return Math.floor(workFinishMoment.diff(workStartMoment) / 1000 / 60);
      }

      return 0;
    }
  },
  methods: {},
  beforeRouteEnter(to, from, next) {
    Promise.all([store.dispatch(FETCH_REVIEW_REPORT, to.params.id)]).then(
      () => {
        next();
      }
    );
  }
};
</script>

<style scoped></style>
